<template>
    <div style="min-width: 500px; min-height: 90vh;">

        <q-card style="min-height: 90vh;">
            <div class="row q-pa-md">
                <div class="col-12">
                    <div class="d-flex justify-content-between">
                        <h4 class="mt-0 mb-3" style="font-size: 26px; font-weight: 300;">
                            Upload File
                        </h4>
                        <span class="d-block">
                            <q-btn @click="$emit('closeUploadFileDialog', false)" class="q-ml-auto" flat
                                   icon="close" round size="small"></q-btn>
                        </span>
                    </div>
                </div>


                <div class="col-12 q-pa-md">
                    <div>
                        <div class="transferType mb-3">
                            <input id="file" @change="onSelectFile()" type="file"
                                   style="display: none"/>
                            <div :class="fileDataURI?'':'image-box'" @click="openFile" class="mx-auto">
                                <div v-if="fileDataURI && file.type==='application/pdf'">
                                    <div style="width: 250px; height: 250px;" class="mx-auto mb-4">
                                        <img src="../assets/pdf.png" alt="" class="w-100" >
                                    </div>
                                    <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI" target="_blank">PREVIEW</q-btn>
                                </div>
                                <div v-else-if="fileDataURI" style="width: 250px; height: 250px;" class="mx-auto mb-4">
                                    <img :src="fileDataURI"  class="w-100">
                                </div>
                                <i v-else class="material-icons icon-cloud">cloud_upload</i>
                            </div>
                            <q-btn @click="uploadFile" :disabled="!file" class="pd-btn d-block mt-3 mx-auto w-50 ">
                                Upload
                            </q-btn>
                        </div>
                    </div>
                </div>
            </div>

        </q-card>
    </div>
</template>

<script>
    import Constants from '../Constants/Constant'
    import { NetworkCommunicator } from '../plugins/NetworkResourceHandler'
    export default {
        name: "UploadFile",
        data:function () {
            return{
                file: '',
                fileDataURI: '',
            }
        },
        methods:{
            openFile(){
                document.getElementById('file').click();
            },
            onSelectFile(){
                this.file = document.getElementById('file').files[0];
                this.fileDataURI = window.URL.createObjectURL(this.file);
            },
            uploadFile () {
                let self = this
                let formData = new FormData()
                formData.append('doc[]', this.file)

                NetworkCommunicator('POST', Constants.api_url + 'upload', false, formData).then(res => {
                    if(res.flag){
                        this.$emit('fileResponseData', res.data.success[0])
                    }else{
                        this.$q.notify(res.message)
                    }
                }).catch(function(err){
                    console.log('Upload File Error', err)
                    this.$q.notify('File Upload failed')
                })
            },
        }
    }
</script>

<style scoped>
    .image-box{
        height: 250px;
        width: 350px;
        border: 1px solid #e0e0e0;
        cursor: pointer;
        text-align: center;
        line-height: 250px;
    }
    .icon-cloud{
        font-size: 50px;
        color: grey;
    }
</style>
